<template>
    <div>
    <h2> Mage's Dungeon:</h2>
    Download Annotated Map:
    <a @click="$emit('downloadImg','Mages Dungeon')">Download</a><br/>
    Download Clean Map:
    <a href="https://s3.amazonaws.com/files.d20.io/images/253918281/fFpnDoZb3LDanaL7nH5WiQ/original.jpg?163606754355" target="_blank">Map</a><br/>
    <v-row>
        <v-col>
            <img id="Mages Dungeon" :src="require('../../../assets/Annotated_Mages_Dungeon_Map.png')"  contain height="899px"/>
        </v-col>
        <v-col>
            <h2>Map Details: </h2>
            <ul>
                <li>All walls and doors are magically enchanted and cannot be destroyed or tunneled through</li>
                <li>Most of the map dimly lit unless specified otherwise, and players can only see 40 feet around them unless they have lowlight vision or the specific room is lit</li>
                <li>Map is 80x74</li>
                <ul>
                    <li>Player Spawn: Pink</li>
                    <li>Treasure: Gold</li>
                    <li>Monsters: Red</li>
                    <li>Areas of interest: Green</li>
                </ul>
            </ul>
            <br/><br/>

            <h3>1) Entry Hall</h3>
            <h4>Area Details:</h4>
            <ul>
                <li>The room is elaborate and high class, with multiple racks of armor in the center, on the east and west side of the room is an ornate mannequin, which are both monster 1, which the party cannot detect unless they use detect magic.</li>
                <li>When the party enters the room monster 2 will ask the party to hand over all weapons and armor before entering deeper. If they agree monster 2 will place their equipment on rack 2, then monster 2 will pull a hidden switch underneath it and that will disable traps 2-6. Party cannot use their gear until it is claimed by killing or sneaking past monster 2 and stealing it from racks.</li>
                <li>no additional lighting, roof is 25 feet tall.</li>
            </ul>
            <h4>Monsters:</h4>
            <ul>
                <li><b>1) <a target="_blank" href="https://www.d20pfsrd.com/bestiary/monster-listings/undead/phantom-armor/phantom-armor-guardian/"> Guardian Phantom Armor CR 2: </a></b> Remains hidden until combat starts unless party refuses to hand over equipment then it will instantly attack</li>
                <li><b>2) <a target="_blank" href="https://www.d20pfsrd.com/bestiary/monster-listings/constructs/homunculus/">Homunculus CR 1: </a></b> Will ask players to hand over all weapons and armor. Will attack if players refuse.</li>
            </ul>
            <h4>Treasure:</h4>
            <ul>
                <li><b>1) Armor 25</b></li>
                <li><b>2) Enchanted Armor 50: </b> If party kills both monster 1s they can roll a craft check DC 18 to put them back together to gain this item.</li>
                <li><b>3) Enchanted Weapon 50</b></li>
            </ul>
            <h4>Areas Of Interest</h4>
            <ul>
                <li><b>1) Lever: </b> This lever when pulled disables traps 2-6 and opens door to its left. Door cannot be opened any other way</li>
                <li><b>2) Blade Trap: </b> Activates magically when a player enters a square it covers. Covers 10ft-10ft square 3d6 slashing damage reflex dc 15 for half. DC 18 perception and disable device. Single activation.</li>
                <li><b>3) Acid Trap: </b> Activates magically when a player enters a square it covers. Fires continuously once activated. Covers 5ft-10ft 2d6 acid damage reflex 12 for half. DC 13 perception and disable device. Continuously fires once activated.</li>
                <li><b>4) Cold Trap: </b> Activates magically when a player enters a square it covers. Fires continuously once activated.  Covers 5ft-10ft 2d6 cold damage reflex 12 for half. DC 13 perception and disable device. Continuously fires once activated</li>
                <li><b>5) Electricity Trap: </b> Activates magically when a player enters a square it covers. Covers 5ft-10ft 2d6 electricty damage reflex 12 for half. DC 13 perception and disable device. Continuously fires once activated</li>
                <li><b>6) Fire Trap: </b> Activates magically when a player enters a square it covers. Fires continuously once activated. Covers 5ft-10ft 2d6 fire damage reflex 12 for half. DC 13 perception and disable device. Continuously fires once activated</li>
            </ul>
            <br/><br/>
        </v-col>
    </v-row>
    <h3>2) Hallway</h3>        
    <h4>Area Details:</h4>
    <ul>
        <li>A moderately lit long hallway with the carving of some strange copyrighted monster carved into it. As you enter you can hear the sounds of whistling and whirring of metal.</li>
        <li>no additional lighting, roof is 25 feet tall.</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Arachnid Robot CR 1/2: </b> Attacks on sight</li>
        <li><b>2) Bronze Sentinel CR 3: </b> Attacks on sight</li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>S1) Small Gold Pile: </b> Gold is at bottom of stairwell and can be obtained after unlocking the door.</li>
        <li><b>M1) Medium Gold Pile: </b> Gold sits 20 feet up a broken stairwell, acrobatics check dc 23 to jump from ledge to ledge obtain it.</li>
    </ul>
    <h4>Areas Of Interest</h4>
    <ul>
        <li><b>1) Locked Stairwell: </b> DC 18 disable device opens door revealing a destroyed stairwell, players can jump to a ledge acrobatics 23 to gain treasure S1</li>
        <li><b>2) Secret Door: </b> DC 18 Perception check reveals this wall as a fake allowing them to open it.</li>
        <li><b>3) Locked Door: </b> This door cannot be opened any way other than using area 1 AoI 1</li>
    </ul>
    <br/><br/>


    <h3>3) Hallway of Statues</h3>
        <h4>Area Details:</h4>
        <li>purple glow doesn't provide any additional lighting, roof is 25 feet tall.</li>
    <ul>
        <li>A very quiet hallway filled with highly details statues and a strange purple glow that appears to come from nowhere.</li>
        <li>The Celedons here will stay hidden and are undetectable except through magic or attacking one. If one is detected and attacked all will attack.</li>
    </ul>
    <h4>Monsters:</h4>
    <ul> 
        <li><b>1) <a target="_blank" href="https://www.d20pfsrd.com/bestiary/monster-listings/constructs/celedon/">Celedon CR 1:</a> </b> Celedons select Prophet's Touch as their granted power.</li>
        <li><b>2) <a target="_blank" href="https://www.d20pfsrd.com/bestiary/monster-listings/constructs/celedon/">Large Celedon CR 1:</a> </b> Celedons select Prophet's Touch as their granted power. Will wait until a player crosses over AoI 2 then will attack in a surprise round unless detected sooner. Celedon and has 5 ft of extra reach and +1 to attack and damage.</li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Spell/Maneuver 40</b></li>
    </ul>
    <h4>Areas Of Interest</h4>
    <ul>
        <li><b>1) Secret Door: </b> If players approach secret door from this side the can recognize it as a secret door and open if from this side</li>
        <li><b>2) Ambush Spot: </b> If players reach this area or cross past it monster 2 will attack</li>
    </ul>
    <br/><br/>


    <h3>4) Monster Arena</h3>
        <h4>Area Details:</h4>
    <ul>
        <li>the Arena is brightly lit by large glowing rocks on the roof, the hallways have normal lighting.</li>
        <li>Roof is 50 ft high in the main arena, 25 ft in the hallways and prison.</li>
        <li>When players enter the area they can make a perception check DC 13, if they succeed they can hear the loud yells of a strange monster, if they also succeed a knowledge nature dc 13 the recognize it as the sound of a giant ape.</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Large Celedon CR 1: </b>Celedons select Prophet's Touch as their granted power. Will wait until a player crosses over AoI 1 or engages monster 2 then will sneak up behind party attempting to stun any spellcasters it sees. Being large Celedon and has 5 ft of extra reach, +1 to attack and damage, and +10 Hit points.</li>
        <li><b>2) Dire Ape CR 3: </b> When players see ape they can make a knowledge nature check DC 18, if they succeed they notice it eyes and movements reveal it is smarter than a regular ape, and if they also succeed a sense motive check they notice it is occasionally glancing at AoI 2. If players reduce Dire Ape to below 1/4 of total health it will attempt to disengage and pull AoI 2.</li>
        <li><b>3) Ostrich CR 1: </b> Once its door opens will immediately attack players or monster 2 whichever is easier to get to.</li>
        <li><b>4) Tiger CR 4: </b> Once its door opens will immediately attack players or monster 2 whichever is easier to get to.</li>
        <li><b>5) Velociraptor CR 2: </b> Once its door opens will immediately attack players or monster 2 whichever is easier to get to.</li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Weapon 25</b></li>
        <li><b>2) 4-8 Potions 50</b></li>
        <li><b>3) E+ Stats 25: </b> Players can harvest the nearby mushrooms to make a steroid with a DC 23 knowledge nature check or dc 18 survival. Players can attempt multiple times, and this is assistable, but are aware that if they mess it up the mushrooms may release a dangerous spore. If they fail their check by 4 or more they and all who assisted must make a dc 14 fortitude save or be poisoned: Frequency 1/round for 4 rounds; Cure 1 save, effect: 1d3 dexterity damage</li>
        <li><b>4) Stats 50</b></li>
    </ul>
    <h4>Areas Of Interest</h4>
    <ul>
        <li><b>1) Ambush Spot: </b> Once players cross past here the Celedon and dire ape will both attack.</li>
        <li><b>2) Lever: </b> Once pulled by monster 2 or players it will begin a mechanism that will open door AoI 3 and open doors 4-7 over time. It opens a new door every 2 rounds in order: 4, 5, 7, 6.</li>
    </ul>
    <br/><br/>


    <h3>5) Servant's Quarters</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>A musty room that hasn't appeared to get any use in a long time, there is destroyed furnature and lots of beds.</li>
        <li>Once players take any item from inside the room monster 1 attacks.</li>
        <li>Area has no additional lighting, roof is 15 feet tall</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Medium Animated Object CR 3: </b> Cannot be detected except through magic or being attacked, will wait until attacked, detected, or until players take any item from inside room to attack party.</li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Stats 25</b></li>
        <li><b>2) Stats 50</b></li>
        <li><b>3) 2-4 potions 50</b></li>
    </ul>   
    <br/><br/>    

    
    <h3>6) Back Hallway</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>A very long hallway, still lit by a dim purple light. An odd blue ring on the ground can be seen near the end of it.</li>
        <li>Area has no additional lighting, roof is 25 feet tall</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) small Aether Elemenal CR 1: </b> Will attack players as soon as it can, cannot go further than 30 feet from magic ring at AoI 2. Dies if players destroy AoI 2</li>
    </ul>        
    <h4>Areas Of Interest</h4>
    <ul>
        <li><b>1) Very Locked Door: </b> This door is indestructable, unpickable and locked. If players get to the other side it reveals a destroyed staircase that leads nowhere.</li>
        <li><b>2) Magic Ring: </b> This magic ring is visible on the ground, if players roll a knowledge arcana dc 18 they can recognize it as a magic ring binding monster 1. If they fail this check by 4 or less they still know what the magic ring does but do not become informed that if they fail they could disable the ring without killing monster 1. If a player rolls a spellcraft check as a standard action while knowing what it does DC 16 it disables it killing monster 1, if they fail this check by 5 or more it instead allows monster 1 to roam freely.</li>
        <li><b>3) Secret Door: </b> DC 25 perception check notices this wall as a secret door and allows it to be opened.</li>
    </ul>
    <br/><br/>

    
    <h3>7) Ritual Room</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>A room dimly lit by purple light reveals a half completed ritual in the center of the room.</li>
        <li>Room has dim lighting, roof is 15 feet tall.</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Medium Water Elemental CR 3</b> </li>
        <li><b>2) Medium Fire Elemental CR 3</b> </li>
        <li><b>3) Medium Earth Elemental CR 3</b> </li>
        <li><b>4) Medium Air Elemental CR 3</b> </li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Typed Spell/Maneuver 60</b></li>
        <li><b>2) Spell/Maneuver 40</b></li>
        <li><b>3) Typed Spell/Maneuver 40: </b> Can only be obtained after the ritual is completed and mosters 1-4 are defeated.</li>
        <li><b>4) Resurrective 75: </b> Can only be obtained after the ritual is completed and mosters 1-4 are defeated, if they roll over 20 on the spellcraft check</li>
        <li><b>L1) Large Gold Pile: </b> Can only be obtained after the ritual is completed and mosters 1-4 are defeated, if they roll over 25 on the spellcraft check.</li>
    </ul>
    <h4>Areas Of Interest</h4>
    <ul>
        <li><b>1) Ritual: </b> Players are aware they can complete the ritual without any knowledge check. Players can attempt a knowledge arcana check DC 10 to know it will summon harnessable power, DC 18 to know it will summon monsters as well, DC 22 to know it will summon elementals, DC 26 to know it what kinds of elementals it summons. Players can attempt a spellcraft check to complete the ritual. If they roll the check monsters 1-4 appear. If they beat a DC 20 and by each 5 over the dc the party succeeds by all monsters lose -1 attack and damage. For each 5 they fail by the monsters receive a +1 to attack and damage. </li>
        <li><b>2) Secret Door: </b> With a DC 26 perception check players can notice the secret door, opening it and revealing the back of a painting on the other side attached to the wall, if they cut their way through it monster 1 in area 8 starts combat with half health and is staggered for 1 round.</li>
    </ul>
    <br/><br/>

    
    <h3>8) Main Hallway</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>Lots of unlit torch sconces line the floor in this room.</li>
        <li>Area has no additional lighting, roof is 25 feet tall</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Living Cave Painting CR 4: </b> Will not go further than 100 feet from painting. If players beat DC 24 knowledge arcana check on monster they learn that the painting is bound to living cave painting and destroying it will harm monster. If they only beat DC 16 they learn there may be other ways to harm painting than just attacking it.</li>
        <li><b>2) Mutant Goblin CR 3</b></li>
        <li><b>3) Clockwork Goblin CR 3</b></li>
        <li><b>4) Medium Fire elemental CR 3</b></li>
        <li><b>5) Repair Robot CR 2</b></li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) E+ weapon 75</b></li>
        <li><b>2) Spell/Maneuver 40</b></li>
        <li><b>3) L+ weapon 75: </b> Once players defeat monster 1 they can make a craft or performance check dc 24 to paint a weapon and bring it to life.</li>
        <li><b>4) Metamagic Feat 150</b></li>
        <li><b>5) Lvl+ Spell/Manveuver</b></li>
        <li><b>S1) Small Gold Pile: </b> A bunch of rubble sits on this staircase, a large rock seems to sit on top of some gold. With a strength check DC 24 players can remove boulder. Players can assist one player, If players fail by 10 or more player and all who assist take 6d6 bludgeoning damage as roof caves in a little, but can obtain gold after. Players can only attempt this check once.</li>

    </ul>
    <h4>Areas Of Interest</h4>
    <ul>
        <li><b>1) Large Painting: </b> a large painting of a group of people dancing, one painting leaps off the painting and attacks becoming monster 1. Paining has an armor class of 10, and a hardness of 5. If players attack the painting on the wall it deals damage half that damage to monster 1, unless they use area of effect damage, which deals full damage to monster 1, fire damage deals 1.5x damage to monster 1. If an area of effect ability hits both the living cave paining and the large painting it only damages the living cave painting once, whichever damage would be higher. Once players have killed monster 1 if they roll a DC 28 perception check they notice the secret door behind the painting. Lower the DC by 1 for each 10 points of damage dealt to the painting.</li>
        <li><b>2) Fire Jet: </b> Fire jets are already on before players get there. Each fire jet deals 3d6 fire damage, reflex dc 16 for half. Disable Device DC 26 to disable, or alternatively are disabled by using AoI lever 4.</li>
        <li><b>3) Electricity Trap: </b> Electricty trap is already on before players get there. Trap deals 6d6 electricty damage, reflex dc 16 for half. Disable Device DC 22 to disable.</li>
        <li><b>4) Lever: </b> Pulling this lever disables all traps AoI 3.</li>
        <li><b>5) Ruined Staircase: </b> This staircase is covered in rubble, a large boulder is holding up part of the roof, but you see some gold underneath it. If someone could life the boulder just a few inches you could get it without the roof caving in.</li>
    </ul>
    <br/><br/>

    
    <h3>9) Prison</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>This prison smells of blood, a fearsome looking prison guard patrols the area.</li>
        <li>no lighting, roof is 15 feet tall.</li>

    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Flesh Golem CR 7</b> Will hide if players attempt to use ranged weapons on it. Can repair itself when not in combat for 10 health a round. Wont leave the prison.</li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) roll x2 Feat 150</b></li>
        <li><b>2) 4-8 Potions 25</b></li>
        <li><b>3) Resurrective 75</b></li>
        <li><b>4) E+ armor Enchantment 125</b></li>
        <li><b>M1) hidden unless given to them my prisoner.</b></li>
    </ul>
    <h4>Areas Of Interest</h4>
    <ul>
        <li><b>1) Locked Door: </b> Players can attempt a disable device check DC 24 to open door.</li>
        <li><b>2) Stronly Locked Door: </b> Players can attempt a disable device check DC 29 to open door.</li>
        <li><b>3) Ex Archmage: </b> If players talk to the ex-archmage they can attempt a DC 29 intimidate, 24 diplomacy, 24 bluff, to convince him to give them treasure M1. If they open door lower DC's by 5. Killing Prisoner reveals nothing.</li>
    </ul>
    <br/><br/>

    
    <h3>10) Armory</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>This room has smells of grease and fire, and you can hear the sound of some sort of angry animal from within.</li>
        <li>Room has no additional lighting and roof is 20 feet tall</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Owlbear CR 4: </b> First round of combat it spends its round destroying its cage</li>
        <li><b>2) Guardian Phantom Armor CR 2 </b></li>
        <li><b>3) Mannaquin Robot CR 2 </b></li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Enchanted Weapon 100: </b> Players Can attempt a craft check DC 16 to turn this into a Enchanted R+ Weapon 100. For each 5 they succeed or fail check increase or decrease price by 25</li>
        <li><b>2) Enchanted armor 100: </b> Players Can attempt a craft check DC 19 to turn this into a R+ Enchanted Armor 100. For each 5 they succeed or fail check increase or decrease price by 25</li>
        <li><b>3) Armor 25: </b> Players Can attempt a craft check DC 14 to turn this into a Typed Armor 25, then for each 5 past that increase the rarity by one step. For each 5 they fail the check increase price by 15 gp</li>
        <li><b>S1) Small Gold Pile: </b> Perception DC 21 to notice gold.</li>
    </ul>
    <br/><br/>

    
    <h3>11) Grand Ritual Room</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>This large room is lit by a glowing yellow circle on the ground. One round after the players enter the room Monster 1 Appears.</li>
        <li>This large room is lit, and the roof is 30 feet tall.</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Ceustodaemon CR 6: </b> Once per round the ceustodaemon can spend a movement action to summon an elemental, this doesn't provoke attacks of opportunity.</li>
        <li><b>2) Medium Fire Elemental CR 3 </b></li>
        <li><b>3) Medium Water Elemental CR 3 </b></li>
        <li><b>3) Medium Earth Elemental CR 3 </b></li>
        <li><b>3) Medium Air Elemental CR 3 </b></li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Level Up Cursed Chest: </b> If players activate cursed chest it spawns a nixudaemon, and rewards a level up if it is defeated.</li>
        <li><b>2) Weapon Enchantment 100 </b> </li>
        <li><b>3) Armor Enchantment 100 </b> </li>
        <li><b>4) Spell/Maneuver 40</b></li>
        <li><b>5) Typed Spell/Maneuver 40: </b> Players can gain the blessings of the magic god by succeeding a dc 14 knowledge religion or arcana check.</li>
        <li><b>M1) Medium Gold Pile: </b> Players can gain the blessings of the magic god by succeeding a dc 19 knowledge religion or arcana check.</li>
    </ul>
    <h4>Areas Of Interest</h4>
    <ul>
        <li><b>1) Grand Summoning Ritual: </b> Players can learn they can disrupt the ritual with a dc 19 knowledge arcana. A player can then spend a full round action attempting a dc 24 spellcraft check to disrupt the ritual stopping monster 1 from spawning additional elementals and giving monster 1 and spawned elementals a -2 to attack and damage.</li>
    </ul>
    <br/><br/>

    
    <h3>12) Execution Hall</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>This area appears to have the remains of multiple creatures both mechanical and biological, the scrapes along the wall reveal that at some point this room was used to pit monsters against each other.</li>
        <li>Room has no additional lighting and roof is 20 feet tall</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Clockwork Gunslinger CR 7: </b> Clockwork Gunslinger will watch AoI 1 and shoot at players if they attempt to move to disable lever in area 8. Reduced Hitpoints to 70, and is CR 5, and worth 1600 exp</li>
        <li><b>1) Gearsman Robot CR 4</b></li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Feat 125</b></li>
        <li><b>1) Fighter Perk 150</b></li>
    </ul>
    <h4>Areas Of Interest</h4>
    <ul>
        <li><b>1) Patrol Point: </b> Monster 1 will move to this area and shoot at players if they attempt to disable traps in area 8.</li>
        <li><b>2) Strong Smell: </b> Before entering door players are assaulted by a strong pungent smell, and a strong metal door clearly made to keep something powerful in.</li>
        <li><b>3) Tough Lever: </b> Lever is very hard to pull requiring a dc 15 strength check, once lever has been pulled door will remain open for 3 rounds and then close again.</li>
    </ul>
    <br/><br/>
    
    <h3>13) Shrine and Storage</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>A shrine to a strange god is on the right side of the room as you enter, and a door on the left that says "junk storage" is on the right.</li>
        <li>The shrine has no additional lighting, the storage area is very dark, and players can only see 10 ft once inside. Roof in shrine is 20 feet, in storage area it is 10</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Junk Golem CR 4: </b> Once players enter its sight it will jump to its feet and surprise them.</li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Spell/Maneuver 40</b></li>
        <li><b>2) R+ Weapon Enchantment 100: </b> If players can roll a DC 23 craft or knowledge arcana they can receive the god of magics blessing for their weapon.</li>
        <li><b>3) Weapon Enchantment 100</b></li>
        <li><b>4) 2-4 potions 25</b></li>
            <li><b>S1) Small Gold Pile: </b> If players can roll a DC 18 knowledge arcana or religion they can gain this gold.</li>
    </ul>
    <h4>Areas Of Interest</h4>
    <ul>
        <li><b>1) Dart Trap: </b> Activates on pressure tile on either of the entrance tiles, Darts continuously fly out from the wall towards the entrance in changing patterns covering the whole hallway. Can only be disabled near the west wall. the darts are coming from. DC 18 disable check. 2d6 piercing damage and 1d6 bleed damage until healed. reflex 16 halves damage and negates bleed.</li>
        <li><b>2) Whirling Blades Trap: </b> Activates on pressure tile, multiple blades comes from the walls and floor spinning and hurting anyone who passes. DC 18 to detect and disable. Deals 3d6 slashing damage, reflex dc 15 for half.</li>
        <li><b>3) Enhanced Whirling Blades Trap: </b> activates on pressure tile, multiple blades comes from the walls and floor spinning and hurting anyone who passes. DC 23 to detect and disable. Deals 4d6 slashing damage, reflex dc 17 for half.</li>
        <li><b>4) Fire Trap: </b> Magically Activated when a player moves into the square, covers the whole 5x15 area. DC 19 to detect and disable. Deals 3d6 fire damage, reflex dc 17 for half.</li>           
    </ul>
    <br/><br/>
    
    <h3>14) Repair Bay</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>This room smells of oil and grease, 3 robots huddle around 1 larger robot on the table reattaching parts, before leaping up to attack once the players open the door.</li>
        <li>Room has no additional lighting, roof is 15 feet tall.</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Repair Robot CR 2: </b> Will try to heal the Iron Sentinel as fast as possible before netting players.</li>
        <li><b>1) Iron Sentinel CR 5: </b> Starts at 54 health</li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Typed E+ Weapon 100</b></li>
        <li><b>2) Stats 25</b></li>
        <li><b>3) Resurrective 125</b></li>
        <li><b>4) Weapon Enchantment 100: </b> With a DC 20 craft or heal check players can access this weapon enchantment</li>
        <li><b>S1) Small Gold Pile: </b> With a DC 20 Perception check players can find this gold.</li>
    </ul>
    <br/><br/>

    
    <h3>15) Secret Hallway</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>hallway has no additional lighting, roof is 10 feet tall.</li>
    </ul>        
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Resurrective 125</b></li>
    </ul>
    <h4>Areas Of Interest</h4>
    <ul>
        <li><b>1) Secret Door 1: </b> Players can open this from the inside with no check.</li>
        <li><b>2) Acid Trap: </b> Magically activated when a player moves into the square, covers the whole area, continuous firing, players can notice and disable this with a DC 24 perception check and DC 16 disable device check. Deals 4d6 acid damage reflex 16 for half</li>
        <li><b>3) Fire Trap: </b> Magically activated when a player moves into the square, covers the whole area, continuous firing, players can notice and disable this with a DC 22 perception check and DC 18 disable device check. Deals 4d6 Fire damage reflex 16 for half</li>
        <li><b>5) Secret Door 2: </b> Players can open this from the inside with no check.</li>
    </ul>
    <br/><br/>

    
    <h3>16) Archmage's Lab</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>This magical lap is lit with a strange glowing purple mushroom with a large empty aquarium, and a large mirror with intricate carvings around it on the west side of the room.</li>
        <li>Whole room is dimly lit, roof in main room is 20 feet high, in the side rooms roof is 10 feet high.</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Mutant Goblin CR 3</b></li>
        <li><b>2) Clockwork Mage CR 9: </b> Starts with 80 health. Uses Evocation wand. Seems very high CR but is actually quite weak.</li>
        <li><b>3) Large Aether Elemental CR 5: </b> Elemental will only attack if players enter its part of the room and will not enter parts of the room lit by purple mushrooms unless it has already been revealed by them. If players bring purple mushrooms to its location it will make it visible.</li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) 2-4 potions 25</b></li>
        <li><b>2) Spells/Maneuvers 40</b></li>
        <li><b>3) Magic Perk 125</b></li>
        <li><b>4) Perk 125: </b> With a DC 24 knowledge arcana check players can obtain this perk by using the magical mirror to enhance their abilities.</li>
        <li><b>5) Spells/Maneuvers 40</b></li>
        <li><b>6) Typed Spells/Maneuvers 60</b></li>
        <li><b>7) Typed Spells/Maneuvers 60</b></li>
        <li><b>8) Level Up 200</b> </li>
    </ul>
    <h4>Areas Of Interest</h4>
    <ul>
        <li><b>1) Secret Door: </b> DC 26 perception check will reveal this secret door and allow players to open it.</li>
        <li><b>2) Purple Mushroom: </b> The whole room is lit with these purple mushrooms, players can learn it reveals invisible creatures with a DC 23 Knowledge arcana check, and harvest it with a dc 19 survival check.</li>
    </ul>
    <br/><br/>

    
    <h3>17) Poison Room</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>This room is filled with a horrid stench, on entry players must roll a dc 14 fortitude check or be sickened for 1 round. A strange silver ooze splashes around in the poison pool in the center then leaps out to attack once the door is open.</li>
        <li>Room has no additional lighting, roof is 10 feet high.</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Adaptive Ooze CR 7: </b> Is very Powerful for its CR</li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Misc Stats 25</b> </li>
        <li><b>2) Utility Perk 125</b></li>
        <li><b>3) 4-8 Typed Potions 50: </b> Players are aware they can obtain some potions from toxic waste in center of room with a DC 19 survival or heal check, but if they mess it up it might create a mishap. If they fail by 5 or more it releases toxic gas and players inside room must make a DC 17 fortitude save or receive 1d4 constitution damage, but they can retry if they want.</li>
    </ul>        
    <br/><br/>
    
    <h3>18) Spare Part Storage</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>This room is filled with blood and limbs of previous habitants of the area.</li>
        <li>Room has no additional lighting, roof is 10 feet high.</li>
    </ul>
    <h4>Monsters:</h4>
    <ul>
        <li><b>1) Blood Golem CR 6</b></li>
    </ul>
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Stats 25</b></li>
        <li><b>2) Stats 25: </b> Requires a DC 21 heal check or craft check.</li>
        <li><b>3) Stats 50</b></li>
    </ul>        
    <br/><br/>
    
    <h3>19) Enhanced Interrogation Room</h3>
    <h4>Area Details:</h4>
    <ul>
        <li>It appears that once upon a time some very friendly conversations happened here that included lots of blood.</li>
        <li>Room has no additional lighting, roof is 10 feet high.</li>
    </ul>        
    <h4>Treasure:</h4>
    <ul>
        <li><b>1) Misc Stats 25</b></li>
        <li><b>2) 2-4 Typed Potions 75</b></li>
        <li><b>3) Level Up 250</b></li>
    </ul>                
    </div>
</template>
            
<script>
import {
VRow,
VCol,
} from "vuetify/lib";
export default {
  components: {    
    VRow,
    VCol,
  },
  data(){
    return{
        
    }
  },
  methods:{

  }
}
</script>